
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Tq4R", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $a2725444c60d8295$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $9iWJ8 = parcelRequire("9iWJ8");

var $fvAxO = parcelRequire("fvAxO");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-dce5b1793d";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $a2725444c60d8295$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    (0, $k2OeR.isPerformanceOnetrustEnabled)() && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedRequestCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const experimentOverrides = (0, $EyEcw.getExperimentOverrides)(parsedRequestCookies);
    const featureGateOverrides = (0, $EyEcw.getFeatureGateOverrides)(parsedRequestCookies);
    const userAgent = window.navigator.userAgent;
    const pollinatorCheck = userAgent.includes("Pollinator");
    let finalExperimentOverrides = experimentOverrides;
    let finalFeatureGateOverrides = featureGateOverrides;
    if (pollinatorCheck) {
        finalExperimentOverrides = Object.values((0, $9iWJ8.experiments)).reduce((acc, experiment)=>{
            acc[experiment.experimentName] = {
                [experiment.parameterName]: experiment.defaultValue
            };
            return acc;
        }, {});
        finalFeatureGateOverrides = Object.entries((0, $fvAxO.featureFlags)).reduce((acc, [, featureFlagObj])=>{
            acc[featureFlagObj.featureFlagName] = false;
            return acc;
        }, {});
    }
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        }
    }).then(()=>{
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    pureClientMode: true,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    agileArticle: window.agileArticle,
                    agileOverview: window.agileOverview,
                    tutorial: window.tutorial,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    anchorContents: window.anchorContents,
                    persona: window.persona,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    userAgent: userAgent,
                    children: Component
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                analyticsWebClient: analyticsWebClient,
                location: window.location,
                pricing: window.prices,
                availableProducts: window.availableProducts,
                agileArticle: window.agileArticle,
                agileOverview: window.agileOverview,
                tutorial: window.tutorial,
                templates: window.templates,
                partnerTemplates: window.partnerTemplates,
                collections: window.collections,
                categories: window.categories,
                userProfile: window.userProfile,
                userProfileStatus: window.userProfileStatus,
                userContext: window.userContext,
                userContextStatus: window.userContextStatus,
                loggedOutContext: window.loggedOutContext,
                loggedOutContextStatus: window.loggedOutContextStatus,
                countryCode: window.countryCode,
                anchorContents: window.anchorContents,
                composition: window._uniformPreloadedComposition,
                isUniformPlayground: window.isUniformPlayground,
                persona: window.persona,
                teamType: window.teamType,
                keyword: window.keyword,
                mlTemplateIds: window.mlTemplateIds,
                referrer: window.referrer,
                anchor: window.anchor,
                subAnchor: window.subAnchor,
                children: Component
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("EyEcw", function(module, exports) {

$parcel$export(module.exports, "getExperimentOverrides", function () { return $a71889fc68f9e7b9$export$8022ee0ca9bf74d6; });
$parcel$export(module.exports, "getFeatureGateOverrides", function () { return $a71889fc68f9e7b9$export$219a3f64f0a96356; });

var $5GZK9 = parcelRequire("5GZK9");
const $a71889fc68f9e7b9$export$8022ee0ca9bf74d6 = (parsedRequestCookies)=>{
    const expOverride = "atlassian_exp_overrides";
    for (const cookieKey of Object.keys(parsedRequestCookies)){
        if (cookieKey === expOverride && parsedRequestCookies[expOverride]) return $a71889fc68f9e7b9$export$d180d40f1827eef7(parsedRequestCookies[expOverride]);
    }
    return {}; // return empty overrides if none are found
};
const $a71889fc68f9e7b9$export$219a3f64f0a96356 = (parsedRequestCookies)=>{
    const fgOverride = "atlassian_feature_gate_overrides";
    for (const cookieKey of Object.keys(parsedRequestCookies)){
        if (cookieKey === fgOverride && parsedRequestCookies[fgOverride]) return $a71889fc68f9e7b9$export$d180d40f1827eef7(parsedRequestCookies[fgOverride]);
    }
    return {}; // return empty overrides if none are found
};
const $a71889fc68f9e7b9$export$d180d40f1827eef7 = (cookie)=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5GZK9))).decompressFromBase64(cookie));
    } catch (e) {
        return {};
    }
};

});


parcelRegister("a6B8g", function(module, exports) {

$parcel$export(module.exports, "FourOhFourPage", function () { return $2f0db47d14246c69$export$20dde44a04c91eb6; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $luVwe = parcelRequire("luVwe");
const $2f0db47d14246c69$export$20dde44a04c91eb6 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {});

});
parcelRegister("luVwe", function(module, exports) {

$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $7767538b4499ca14$export$580adf4c24c28053; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $eXdLM = parcelRequire("eXdLM");
const $7767538b4499ca14$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                    isShowTryNowLink: true,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "404"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eXdLM.MainSection), {})
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("eXdLM", function(module, exports) {

$parcel$export(module.exports, "MainSection", function () { return $a4f8d969ce4472d4$export$b3b6941b6cf0f30; });
/* main.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("bQawl");
var $ca2XB = parcelRequire("ca2XB");
parcelRequire("9Yq3D");
var $1HpTU = parcelRequire("1HpTU");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $a4f8d969ce4472d4$var$contentSectionCss = null;
const $a4f8d969ce4472d4$var$headerStyle = null;
const $a4f8d969ce4472d4$var$textStyle = null;
const $a4f8d969ce4472d4$var$linkTextStyle = null;
const $a4f8d969ce4472d4$var$searchMainContainerStyle = null;
const $a4f8d969ce4472d4$var$searchFormStyle = null;
const $a4f8d969ce4472d4$var$searchContainerStyle = null;
const $a4f8d969ce4472d4$var$searchInputContainerStyle = null;
const $a4f8d969ce4472d4$var$divStyle = null;
const $a4f8d969ce4472d4$var$searchIconButtonStyle = null;
const $a4f8d969ce4472d4$export$b3b6941b6cf0f30 = ()=>{
    const intl = (0, $f6qj2.default)();
    const inputRef = (0, $iSvIT.useRef)(null);
    const [searchText, setSearchText] = (0, $iSvIT.useState)("");
    const sorry = intl.formatMessage({
        id: "404.sorry",
        defaultMessage: "Sorry, the page you're looking for cannot be found"
    }, {
        ...(0, $3FBn4.DEFAULT_VALUES)
    });
    const visitHomepage = intl.formatMessage({
        id: "404.visitHomepage",
        defaultMessage: "Visit our <HomepageLink>homepage</HomepageLink>, get <HelpLink>help</HelpLink>, or try searching"
    }, {
        ...(0, $3FBn4.DEFAULT_VALUES),
        HomepageLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                text: text,
                "aria-label": text,
                href: (0, $3FBn4.useLocalizedHref)("/"),
                type: "inline"
            }),
        HelpLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                text: text,
                "aria-label": text,
                href: (0, $3FBn4.useLocalizedHref)("/resources/support"),
                type: "inline"
            })
    });
    const search = intl.formatMessage({
        id: "404.search",
        defaultMessage: "Search"
    });
    const mainCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1q5112bs _85i5mxpn _1mt1idpf _oqic1crf _1rmjidpf _cjbt1qr7 _pnmbidpf _1kmxgktf _1ggmidpf _1ykz16xz _1maeidpf _i6jxckbl _1lh7idpf _z3nc11ux _wpaiidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_bozgidpf _y4tiidpf _1e0c1txw _2lx21bp4 _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _y3gn1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_1wybhew6 _ect41jfk _k48pbfng _syaz1bqd _1po4webb _1egl1k7u _4t3i1k7u"
                        ]),
                        children: "404"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_ect418gv _k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _syaz1mpp _s7n41q9y _vwz4bs82"
                        ]),
                        children: sorry
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_ect418gv _k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1mpp _s7n41q9y _vwz4bs82"
                        ]),
                        children: visitHomepage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1mt1idpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        id: "wac-search",
                        "data-testid": "search-container",
                        className: (0, $esG4f.default)([
                            "_152t1osq _1e02ze3t _vwz41ejb"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("form", {
                            action: (0, $3FBn4.useLocalizedHref)(`/search`),
                            method: "GET",
                            id: "wac-search-form",
                            "data-testid": "search-form",
                            className: (0, $esG4f.default)([
                                "_vwz41ejb _p12f1fra _19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswh2mm _1akoidpf _c7s7gktf _4puv1tcg _1r3vgktf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                id: "wac-search-container",
                                className: (0, $esG4f.default)([
                                    "_y3gn1h6o _18s85ogf _xc2iidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        id: "wac-search-input-container",
                                        className: (0, $esG4f.default)([
                                            "_1e0c1o8l _12l2u2gc _y3gn1e5h _1bsbr0r7"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1HpTU.TextInput), {
                                            ref: inputRef,
                                            className: "fullWidth",
                                            placeholder: "",
                                            label: "",
                                            name: "q",
                                            id: "search-input",
                                            value: searchText,
                                            onChangeHandler: setSearchText,
                                            "data-testid": "search-input",
                                            "aria-label": "Search Input"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ca2XB.Button), {
                                        text: search,
                                        type: "primary",
                                        size: "small",
                                        className: (0, $esG4f.default)([
                                            "_bfhkrbzz _1lrwpxbi _19it36id _2rko1b66 _80omtlke _s7n4yfq0 _syazu67f _1yt416r1 _6rth12x7 _10531hxd _1di6u7gi _irr3u7gi _n7dw181d _bfw7181d"
                                        ])
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};

});
parcelRegister("bQawl", function(module, exports) {
$parcel$export(module.exports, "Button", function () { return (parcelRequire("ca2XB")).Button; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("ca2XB")).Button; });

var $ca2XB = parcelRequire("ca2XB");

});
parcelRegister("ca2XB", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $62ad7d149d2e5a06$export$353f5b6fc5456de1; });
/* button.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $62ad7d149d2e5a06$var$buttonStyles = {
    primary: {
        // default styles
        darkblue: {
            textColor: "#ffffff",
            buttonBackgroundColor: "#0052cc",
            buttonHoverColor: "#0047B3",
            buttonFocusColor: "#004099",
            border: "none"
        },
        blueprimary700: {
            textColor: "#ffffff",
            buttonBackgroundColor: "#1868DB",
            buttonHoverColor: "#0047B3",
            buttonFocusColor: "#004099",
            border: "none"
        },
        yellow: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#ffab00",
            buttonHoverColor: "#ff991f",
            buttonFocusColor: "#ff8b00",
            border: "none"
        },
        green: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#79f2c0",
            buttonHoverColor: "#57d9a3",
            buttonFocusColor: "#36b37e",
            border: "none"
        },
        lightblue: {
            textColor: "#0052cc",
            buttonBackgroundColor: "#deebff",
            buttonHoverColor: "#B3D4FF",
            buttonFocusColor: "#4c9aff",
            border: "none"
        },
        gray: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "#DFE1E6",
            buttonFocusColor: "#c1c7d0",
            border: "none"
        },
        disabled: {
            textColor: "#97a0af",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        }
    },
    secondary: {
        darkblue: {
            textColor: "#0052cc",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#ebecf0",
            buttonFocusColor: "#deebff",
            border: `0.063rem solid #0052cc`
        },
        blueprimary700: {
            textColor: "#1868DB",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#ebecf0",
            buttonFocusColor: "#deebff",
            border: `0.063rem solid #1868DB`
        },
        yellow: {
            textColor: "#172b4d",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#f4f5f7",
            buttonFocusColor: "#FFF0B3",
            border: `0.063rem solid #ffab00`
        },
        green: {
            textColor: "#172b4d",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#f4f5f7",
            buttonFocusColor: "#e3fcef",
            border: `0.063rem solid #79f2c0`
        },
        white: {
            textColor: "#ffffff",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "rgba(255, 255, 255, 0.10)",
            buttonFocusColor: "rgba(255, 255, 255, 0.20)",
            border: `0.063rem solid #ffffff`
        },
        disabled: {
            textColor: "#97a0af",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        },
        whiteblue: {
            textColor: "#ffffff",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "rgba(255, 255, 255, 0.10)",
            buttonFocusColor: "rgba(255, 255, 255, 0.20)",
            border: `0.063rem solid #0052cc`
        }
    }
};
const $62ad7d149d2e5a06$var$getButtonSize = (size)=>{
    const buttonSize = size?.toLowerCase();
    if (buttonSize && buttonSize === "small") return "small";
    return "large";
};
const $62ad7d149d2e5a06$var$getButtonType = (type)=>{
    const buttonType = type?.toLowerCase();
    if (buttonType === "secondary") return "secondary";
    return "primary";
};
const $62ad7d149d2e5a06$var$isButtonColor = (color)=>{
    return color === "darkblue" || color === "blueprimary700" || color === "yellow" || color === "green" || color === "lightblue" || color === "white" || color === "gray" || color === "disabled";
};
const $62ad7d149d2e5a06$var$getButtonColor = (color, disabled)=>{
    if (disabled) return "disabled";
    const buttonColor = color?.toLowerCase();
    if (buttonColor && $62ad7d149d2e5a06$var$isButtonColor(buttonColor)) return buttonColor;
    return "darkblue";
};
const $62ad7d149d2e5a06$var$getButtonStyles = (type, color)=>{
    const styles = $62ad7d149d2e5a06$var$buttonStyles[type][color]; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return styles ? styles : $62ad7d149d2e5a06$var$buttonStyles.primary.darkblue;
}; /**
    * @deprecated - Please use @/libraries/design/components/button instead
    */ 
const $62ad7d149d2e5a06$export$353f5b6fc5456de1 = ({ text: text, type: type, color: color = "darkblue", size: size, onClick: onClick, url: url, externalLink: externalLink, inputType: inputType, disabled: disabled, className: className, dataEventProps: dataEventProps })=>{
    const buttonType = $62ad7d149d2e5a06$var$getButtonType(type);
    const buttonColor = $62ad7d149d2e5a06$var$getButtonColor(color, disabled);
    const { textColor: textColor, buttonBackgroundColor: buttonBackgroundColor, buttonHoverColor: buttonHoverColor, buttonFocusColor: buttonFocusColor, border: border } = $62ad7d149d2e5a06$var$getButtonStyles(buttonType, buttonColor);
    const buttonSize = $62ad7d149d2e5a06$var$getButtonSize(size);
    const fontSize = buttonSize === "large" ? "1rem" : "0.875rem";
    const height = buttonSize === "large" ? "2.5rem" : "2rem";
    const cursor = disabled ? "not-allowed" : "pointer";
    const styles = null;
    const handleOnClick = (e)=>{
        if (disabled) e.preventDefault();
        else onClick?.(e);
    };
    if ((onClick || inputType) && !url) return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        disabled: disabled,
        type: inputType,
        ...dataEventProps,
        style: {
            "--_1yb8o8o": (0, $43MIc.default)(buttonBackgroundColor),
            "--_pruigo": (0, $43MIc.default)(border),
            "--_srel9g": (0, $43MIc.default)(textColor),
            "--_1hkmuwx": (0, $43MIc.default)(buttonHoverColor),
            "--_15riry1": (0, $43MIc.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $43MIc.default)(fontSize),
            "--_roksyz": (0, $43MIc.default)(height),
            "--_15yp1he": (0, $43MIc.default)(cursor)
        },
        children: text
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        href: url,
        target: externalLink ? "_blank" : undefined,
        rel: externalLink ? "noreferrer" : undefined,
        ...dataEventProps,
        style: {
            "--_1yb8o8o": (0, $43MIc.default)(buttonBackgroundColor),
            "--_pruigo": (0, $43MIc.default)(border),
            "--_srel9g": (0, $43MIc.default)(textColor),
            "--_1hkmuwx": (0, $43MIc.default)(buttonHoverColor),
            "--_15riry1": (0, $43MIc.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $43MIc.default)(fontSize),
            "--_roksyz": (0, $43MIc.default)(height),
            "--_15yp1he": (0, $43MIc.default)(cursor)
        },
        children: text
    });
};

});


parcelRegister("9Yq3D", function(module, exports) {
$parcel$export(module.exports, "TextInput", function () { return (parcelRequire("1HpTU")).TextInput; });

var $1HpTU = parcelRequire("1HpTU");

});
parcelRegister("1HpTU", function(module, exports) {

$parcel$export(module.exports, "TextInput", function () { return $8544b56265ebc142$export$c86715117507e8e5; });
/* text-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");
const $8544b56265ebc142$var$containerStyles = null;
const $8544b56265ebc142$var$labelStyles = null;
const $8544b56265ebc142$var$inputContainerStyles = null;
const $8544b56265ebc142$var$inputStyles = null;
const $8544b56265ebc142$var$errorStyles = null;
const $8544b56265ebc142$var$iconStyles = null;
const $8544b56265ebc142$export$c86715117507e8e5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef((props, ref)=>{
    const { name: name, value: value, id: id, testId: testId, label: label, placeholder: placeholder, disabled: disabled, validation: validation, Icon: Icon, onChangeHandler: onChangeHandler, className: className, autocomplete: autocomplete } = props;
    const [text, setText] = (0, $iSvIT.useState)("");
    const [isValid, setValid] = (0, $iSvIT.useState)(true);
    const [error, setError] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        if (text && validation) {
            const { 0: valid, 1: error } = validation(text);
            if (valid) setError("");
            else setError(error);
            setValid(valid);
        }
        if (!text) setError("");
    }, [
        text
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _1cxkb0wy _gl1i1du8",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                htmlFor: name,
                className: (0, $esG4f.default)([
                    "_syaz1bqd _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm",
                    "input-container"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                        className: (0, $esG4f.default)([
                            "_vchhusvi _bfhki0pe _189eyh40 _1dqonqa1 _1h6d3739 _2rko1y44 _1o9zidpf _4t3i1jvk _bozgftgi _1bsb1osq _1wyb1j6v _vwz4cjiy _y3gn1e5h _syaz1mpp _1idrq25q _4cvx3739 _irr34m1f _27uw3739 _cun91hxd _vbqbq25q _nt751j28 _49pcnqa1 _1hvwt94y",
                            isValid ? "valid-inp" : "invalid-inp"
                        ]),
                        onChange: (e)=>{
                            setText(e.target.value);
                            onChangeHandler && onChangeHandler(e.target.value);
                        },
                        type: "text",
                        ref: ref,
                        name: name,
                        id: id,
                        "data-testid": testId ? testId : id,
                        value: value,
                        placeholder: placeholder,
                        disabled: disabled || false,
                        "aria-invalid": !!error,
                        "aria-errormessage": !!error ? `err${id}` : "",
                        autoComplete: autocomplete
                    }),
                    Icon && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152tidpf _u7coidpf _rjxp19bv _1bsb1tcg _4t3i1tcg _lcxvglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)(Icon, {})
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                id: `err${id}`,
                className: (0, $esG4f.default)([
                    "_syaz1du8 _1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfh1y44"
                ]),
                children: error
            })
        ]
    });
});
$8544b56265ebc142$export$c86715117507e8e5.displayName = "TextInput";

});





parcelRegister("bfGvY", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $831212f3b8a942df$var$hasElementType = typeof Element !== "undefined";
var $831212f3b8a942df$var$hasMap = typeof Map === "function";
var $831212f3b8a942df$var$hasSet = typeof Set === "function";
var $831212f3b8a942df$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $831212f3b8a942df$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$831212f3b8a942df$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($831212f3b8a942df$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$831212f3b8a942df$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($831212f3b8a942df$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($831212f3b8a942df$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($831212f3b8a942df$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$831212f3b8a942df$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $831212f3b8a942df$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("lzzak", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $fb482505c2962b4d$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $fb482505c2962b4d$export$bb5ca5fba6fb4f1f; });

var $iSvIT = parcelRequire("iSvIT");

var $2mGe8 = parcelRequire("2mGe8");
var $fb482505c2962b4d$var$generateUID = function(context) {
    var quartz = context || (0, $2mGe8.counter);
    var prefix = (0, $2mGe8.getPrefix)(quartz);
    var id = (0, $2mGe8.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $fb482505c2962b4d$var$useUIDState = function() {
    var context = (0, $iSvIT.useContext)((0, $2mGe8.source));
    var uid = (0, $iSvIT.useState)(function() {
        return $fb482505c2962b4d$var$generateUID(context);
    })[0];
    return uid;
};
var $fb482505c2962b4d$export$87d05f07e65211f1 = function() {
    var uid = $fb482505c2962b4d$var$useUIDState().uid;
    return uid;
};
var $fb482505c2962b4d$export$bb5ca5fba6fb4f1f = function() {
    var gen = $fb482505c2962b4d$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("2mGe8", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $1b8e643ba833cfcb$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $1b8e643ba833cfcb$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $1b8e643ba833cfcb$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $1b8e643ba833cfcb$export$36e24695f02d4503; });

var $iSvIT = parcelRequire("iSvIT");

var $cFJ5y = parcelRequire("cFJ5y");
var $1b8e643ba833cfcb$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $cFJ5y.generateUID)()
    };
};
var $1b8e643ba833cfcb$export$e575061ef2a070eb = $1b8e643ba833cfcb$export$1921362e86c73c88();
var $1b8e643ba833cfcb$export$b4d5da5f34fb77ad = $iSvIT.createContext($1b8e643ba833cfcb$export$1921362e86c73c88());
var $1b8e643ba833cfcb$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $1b8e643ba833cfcb$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});


parcelRegister("fxdfZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b48c91a1934e1c$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $1xv8a = parcelRequire("1xv8a");
class $b2b48c91a1934e1c$export$2e2bcd8739ae039 extends (0, $iSvIT.Component) {
    constructor(props){
        super(props);
        /** In the event that we only want to show a fallback for a specific error,
   * we can pass a function to shouldShowFallback that will determine if the fallback should be shown
   * Returns true if shouldShowFallback is not provided or if the function returns true
   **/ this.shouldRenderFallback = ()=>{
            if (!this.state.error) return false;
            if (!this.props.shouldShowFallback) return true;
            return this.props.shouldShowFallback(this.state.error);
        };
        this.state = {};
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Call onError callback if provided
        this.props.onError?.(error, info);
        // Log the error
        (0, $1xv8a.Helpers).sendWrapperLoadError(error.message, info.componentStack ?? undefined);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        if (this.shouldRenderFallback()) return fallback;
        return children;
    }
}

});

parcelRegister("cQk7Y", function(module, exports) {

$parcel$export(module.exports, "ALGOLIA_APP_ID", function () { return $bfeeaa29e3f9a245$export$17b978e8ab9e4c58; });
$parcel$export(module.exports, "ALGOLIA_SEARCH_API_KEY", function () { return $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1; });
$parcel$export(module.exports, "ALGOLIA_FACET_KEY", function () { return $bfeeaa29e3f9a245$export$b23c3af39ccf497d; });
$parcel$export(module.exports, "activeSearchIndex", function () { return $bfeeaa29e3f9a245$export$e9dac33bbaf86e02; });
$parcel$export(module.exports, "activeSearchIndexV3", function () { return $bfeeaa29e3f9a245$export$b337d69b7a65e111; });
$parcel$export(module.exports, "AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY", function () { return $bfeeaa29e3f9a245$export$5049c8654c52de2a; });
$parcel$export(module.exports, "sendConversionEventAlgolia", function () { return $bfeeaa29e3f9a245$export$b887d873139badc3; });
$parcel$export(module.exports, "handleAlgoliaConversionMetrics", function () { return $bfeeaa29e3f9a245$export$120e7b764d5fde54; });
$parcel$export(module.exports, "useA11yDropdownAnnouncement", function () { return $bfeeaa29e3f9a245$export$3d596a295dd7fc61; });
$parcel$export(module.exports, "HiddenAriaLiveAnnouncement", function () { return $bfeeaa29e3f9a245$export$e96bd116e2b4049a; });
$parcel$export(module.exports, "shouldEnableAlgoliaAnalytics", function () { return $bfeeaa29e3f9a245$export$607d0b571396563a; });
/* auto-complete-helpers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $2bsWQ = parcelRequire("2bsWQ");

var $f6qj2 = parcelRequire("f6qj2");

var $gFK1O = parcelRequire("gFK1O");

var $1syhO = parcelRequire("1syhO");
const $bfeeaa29e3f9a245$export$17b978e8ab9e4c58 = "CU5KFWE75C";
const $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1 = "8cb0497a0549da256319b1b8178e5421";
const $bfeeaa29e3f9a245$export$b23c3af39ccf497d = "category";
const $bfeeaa29e3f9a245$export$74b39503c55b7612 = "www.atlassian.com.v2";
const $bfeeaa29e3f9a245$export$5b7165c5ebbdd78c = "www.atlassian.com.v2_dev";
const $bfeeaa29e3f9a245$export$9af986fa17e71039 = "www.atlassian.com.v3";
const $bfeeaa29e3f9a245$export$a7eaf02eb519d647 = "www.atlassian.com.v3_dev";
const $bfeeaa29e3f9a245$export$e9dac33bbaf86e02 = $bfeeaa29e3f9a245$export$74b39503c55b7612;
const $bfeeaa29e3f9a245$export$b337d69b7a65e111 = $bfeeaa29e3f9a245$export$9af986fa17e71039;
const $bfeeaa29e3f9a245$export$5049c8654c52de2a = "aa-autocomplete-pce";
async function $bfeeaa29e3f9a245$export$b887d873139badc3({ objectID: objectID, queryID: queryID }) {
    const algoliaApplicationID = $bfeeaa29e3f9a245$export$17b978e8ab9e4c58;
    const algoliaAdminAPIKey = $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1;
    const insightsURL = `https://insights.algolia.io/1/events`;
    const anonymousId = (0, $gFK1O.Cookie).readCookie("ajs_anonymous_id");
    let decodedAnonymousId;
    if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
    decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, "");
    const eventData = {
        events: [
            {
                eventType: "conversion",
                eventName: "Result clicked (global nav)",
                index: $bfeeaa29e3f9a245$export$e9dac33bbaf86e02,
                userToken: decodedAnonymousId,
                objectIDs: [
                    objectID
                ],
                queryID: queryID
            }
        ]
    };
    try {
        const response = await (0, $2bsWQ.fetch)(insightsURL, {
            method: "POST",
            headers: {
                "X-Algolia-Application-Id": algoliaApplicationID,
                "X-Algolia-API-Key": algoliaAdminAPIKey,
                "Content-Type": "text/plain;charset=UTF-8"
            },
            body: JSON.stringify(eventData)
        });
        if (!response.ok) throw new Error(`Error: ${response.statusText}`);
    } catch (error) {
        console.error("Failed to send event:", error);
    }
}
const $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist = ()=>{
    if (localStorage.getItem($bfeeaa29e3f9a245$export$5049c8654c52de2a)) (0, $1syhO.removeLocalStorage)($bfeeaa29e3f9a245$export$5049c8654c52de2a);
};
const $bfeeaa29e3f9a245$var$setPotentialConversionEventLocalStorage = (stringifyConversionEventObject)=>{
    // reset localstorage if already exist
    $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist();
    (0, $1syhO.setLocalStorage)($bfeeaa29e3f9a245$export$5049c8654c52de2a, stringifyConversionEventObject, 3600 // per code comment, ttl in seconds for the localstorage. 3600 secs = 1hr
    );
}; // click events are tracked through the algolia client's
const $bfeeaa29e3f9a245$export$120e7b764d5fde54 = (item)=>{
    if (item.url.includes("/signup")) {
        $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist();
        $bfeeaa29e3f9a245$export$b887d873139badc3({
            objectID: item.objectID,
            queryID: item.queryID,
            position: item.position
        });
    } else if (item.url.includes("/software/")) {
        const stringifyAttributes = JSON.stringify({
            objectID: item.objectID,
            queryID: item.queryID,
            position: item.position
        });
        $bfeeaa29e3f9a245$var$setPotentialConversionEventLocalStorage(stringifyAttributes);
    }
};
function $bfeeaa29e3f9a245$export$3d596a295dd7fc61(props) {
    const { resultsCount: resultsCount, searchTerm: searchTerm } = props;
    const [dropdownAnnouncement, setDropdownAnnouncement] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        setDropdownAnnouncement("");
    }, [
        searchTerm
    ]);
    const intl = (0, $f6qj2.default)();
    (0, $iSvIT.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDropdownAnnouncement(intl.formatMessage({
                id: "AutoCompleteSearchBar.dropdown.announcement",
                defaultMessage: '{resultsCount} results displayed for search-term "{searchTerm}"'
            }, {
                resultsCount: resultsCount,
                searchTerm: searchTerm
            }));
        }, 2000);
        return ()=>clearTimeout(timer);
    }, [
        resultsCount,
        searchTerm
    ]);
    return {
        dropdownAnnouncement: dropdownAnnouncement
    };
}
const $bfeeaa29e3f9a245$export$e96bd116e2b4049a = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-live": "polite",
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsbt94y _4t3it94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogtohxbz _1reo15vq _18m915vq"
        ]),
        children: props.children
    });
}; /**
    * Ignore Algolia analytics for Pollinator user agent.
    */ 
function $bfeeaa29e3f9a245$export$607d0b571396563a() {
    return !(typeof window !== "undefined" && window.navigator.userAgent.includes("Pollinator"));
}

});

parcelRegister("3Bf61", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29f0898d81776aa2$var$_react = $29f0898d81776aa2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $29f0898d81776aa2$var$_chevronRight = $29f0898d81776aa2$var$_interopRequireDefault((parcelRequire("fOYRZ")));
function $29f0898d81776aa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $29f0898d81776aa2$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $29f0898d81776aa2$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $29f0898d81776aa2$var$_chevronRight.default,
        iconType: "utility"
    }));
$29f0898d81776aa2$var$ChevronRightLargeIcon.displayName = "ChevronRightLargeIcon";
var $29f0898d81776aa2$var$_default = module.exports.default = $29f0898d81776aa2$var$ChevronRightLargeIcon;

});
parcelRegister("fOYRZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281ba53efaa7c88b789646091262f5f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b84abdffa30de06b$var$_react = $b84abdffa30de06b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b84abdffa30de06b$var$_baseNew = $b84abdffa30de06b$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b84abdffa30de06b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b84abdffa30de06b$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $b84abdffa30de06b$var$_react.default.createElement($b84abdffa30de06b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.94 6 3.97 2.03 5.03.97l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$b84abdffa30de06b$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $b84abdffa30de06b$var$_default = module.exports.default = $b84abdffa30de06b$var$ChevronRightIcon;

});


parcelRegister("d0cJX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9775286909ac5557$var$_react = $9775286909ac5557$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $9775286909ac5557$var$_chevronLeft = $9775286909ac5557$var$_interopRequireDefault((parcelRequire("8ZHrU")));
function $9775286909ac5557$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9775286909ac5557$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $9775286909ac5557$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $9775286909ac5557$var$_chevronLeft.default,
        iconType: "utility"
    }));
$9775286909ac5557$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $9775286909ac5557$var$_default = module.exports.default = $9775286909ac5557$var$ChevronLeftLargeIcon;

});
parcelRegister("8ZHrU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68c5b95a09f26cb8$var$_react = $68c5b95a09f26cb8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $68c5b95a09f26cb8$var$_baseNew = $68c5b95a09f26cb8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $68c5b95a09f26cb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68c5b95a09f26cb8$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $68c5b95a09f26cb8$var$_react.default.createElement($68c5b95a09f26cb8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$68c5b95a09f26cb8$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $68c5b95a09f26cb8$var$_default = module.exports.default = $68c5b95a09f26cb8$var$ChevronLeftIcon;

});


parcelRegister("Erp3T", function(module, exports) {
$parcel$export(module.exports, "useProductIntent", function () { return (parcelRequire("kjssF")).useProductIntent; });
parcelRequire("eeJVi");
parcelRequire("kjssF");

});
parcelRegister("eeJVi", function(module, exports) {

$parcel$export(module.exports, "ProductKey", function () { return $638022cbdd0e1e88$export$f3a53bd43617a593; });
$parcel$export(module.exports, "products", function () { return $638022cbdd0e1e88$export$b6aad051bad07f12; });
var $638022cbdd0e1e88$export$f3a53bd43617a593;
(function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
})($638022cbdd0e1e88$export$f3a53bd43617a593 || ($638022cbdd0e1e88$export$f3a53bd43617a593 = {}));
const $638022cbdd0e1e88$export$b6aad051bad07f12 = [
    {
        bundle: "jira-software",
        description: "Jira",
        key: "jira-software.ondemand",
        name: "jira"
    },
    {
        bundle: "confluence",
        description: "Confluence",
        key: "confluence.ondemand",
        name: "confluence"
    },
    {
        bundle: "jira-service-management",
        description: "Jira Service Management",
        key: "jira-servicedesk.ondemand",
        name: "jira-servicedesk"
    },
    {
        bundle: "jira-product-discovery",
        description: "Jira Product Discovery",
        key: "jira-product-discovery",
        name: "jira-product-discovery"
    }
];

});

parcelRegister("kjssF", function(module, exports) {

$parcel$export(module.exports, "useProductIntent", function () { return $ead1ccf5e671c3c5$export$93cccec4b411f62; });

var $iSvIT = parcelRequire("iSvIT");

var $eeJVi = parcelRequire("eeJVi");
const $ead1ccf5e671c3c5$export$93cccec4b411f62 = ()=>// eslint-disable-next-line complexity
    (0, $iSvIT.useMemo)(()=>{
        let edition;
        let product;
        if (typeof window === "undefined") return {
            edition: edition,
            product: product
        };
        const params = new URLSearchParams(window.location.search);
        if (window.location.pathname.includes("/software/jira/product-discovery")) {
            product = {
                bundle: "jira-product-discovery",
                description: "Jira Product Discovery",
                key: (0, $eeJVi.ProductKey).JIRA_PRODUCT_DISCOVERY,
                name: "jira-product-discovery"
            };
            edition = "free";
        } else if (window.location.pathname.includes("/software/jira/service-management")) {
            product = {
                bundle: "jira-service-management",
                description: "Jira Service Management",
                key: (0, $eeJVi.ProductKey).JIRA_SERVICE_MANAGEMENT,
                name: "jira-servicedesk"
            };
            edition = "free";
        } else if (window.location.pathname.includes("/software/jira")) {
            product = {
                bundle: "jira-software",
                description: "Jira",
                key: (0, $eeJVi.ProductKey).JIRA_SOFTWARE,
                name: "jira"
            };
            edition = "free";
        }
        if (window.location.pathname.includes("/software/confluence")) {
            product = {
                bundle: "confluence",
                description: "Confluence",
                key: (0, $eeJVi.ProductKey).CONFLUENCE,
                name: "confluence"
            };
            edition = "free";
        }
        const isSignupPage = window.location.pathname.endsWith("/try/cloud/signup");
        const isConfirmationPage = window.location.pathname.endsWith("/ondemand/signup/confirmation");
        if (isSignupPage || isConfirmationPage || window.IS_STORYBOOK) {
            // defaults for the signup page
            if (isSignupPage) {
                edition = "free";
                product = {
                    bundle: "jira-software",
                    description: "Jira",
                    key: (0, $eeJVi.ProductKey).JIRA_SOFTWARE,
                    name: "jira"
                };
            }
            // determine product
            if (params.has("product")) product = (0, $eeJVi.products).find((product)=>product.key === params.get("product"));
            else if (params.has("bundle")) product = (0, $eeJVi.products).find((product)=>product.bundle === params.get("bundle"));
            else if (params.has("products")) product = (0, $eeJVi.products).find((product)=>product.key === params.get("products")?.split(",")[0]);
            // determine edition
            const editionParam = params.get("edition");
            if (editionParam === "free") edition = "free";
            else if (editionParam === "standard") edition = "standard";
            else if (editionParam === "premium") edition = "premium";
        }
        return {
            edition: edition,
            product: product
        };
    }, []);

});


parcelRegister("f448m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af7a6fa2fff8eb61$var$_react = $af7a6fa2fff8eb61$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $af7a6fa2fff8eb61$var$_close = $af7a6fa2fff8eb61$var$_interopRequireDefault((parcelRequire("i3sQU")));
function $af7a6fa2fff8eb61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $af7a6fa2fff8eb61$var$CrossIcon = (props)=>/*#__PURE__*/ $af7a6fa2fff8eb61$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $af7a6fa2fff8eb61$var$_close.default
    }));
$af7a6fa2fff8eb61$var$CrossIcon.displayName = "CrossIcon";
var $af7a6fa2fff8eb61$var$_default = module.exports.default = $af7a6fa2fff8eb61$var$CrossIcon;

});
parcelRegister("i3sQU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d24ee34c820fd1da$var$_react = $d24ee34c820fd1da$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d24ee34c820fd1da$var$_baseNew = $d24ee34c820fd1da$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d24ee34c820fd1da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d24ee34c820fd1da$var$CloseIcon = (props)=>/*#__PURE__*/ $d24ee34c820fd1da$var$_react.default.createElement($d24ee34c820fd1da$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$d24ee34c820fd1da$var$CloseIcon.displayName = "CloseIcon";
var $d24ee34c820fd1da$var$_default = module.exports.default = $d24ee34c820fd1da$var$CloseIcon;

});



var $7Tq4R = parcelRequire("7Tq4R");

var $a6B8g = parcelRequire("a6B8g");
(0, $7Tq4R.init)((0, $a6B8g.FourOhFourPage));


//# sourceMappingURL=404.5f36e6a2.js.map
